import "../../../style/staticPages.css";


export const static718 = (
    <div className="staticNormalPage staticPageText">
        <div className="partialContainer ">
            <h2 className="">
            Vorlesen
            </h2>

            <div className="lehguParagraph ">
               <p>Ungeachtet von <strong>Schulart und Fach</strong> gehört das <strong>Vorlesen unterschiedlichster Textarten </strong>zum Schulalltag 
               (z.B. kurze Arbeitsanweisungen, Geschichten, Gedichte, Textaufgaben und Mitteilungen an Elternabenden). Beim <strong>Vorlesen</strong> 
               oder auch <strong>Vortragen</strong> kommt es darauf an, die <strong>Zuhörenden mitzunehmen</strong> und ihnen den <strong>Text 
               angemessen und ansprechend</strong> zu präsentieren. Die <strong>Wirkung des Stimmklangs</strong> gewinnt, im Gegensatz zu alltäglichen 
               Sprechsituationen, an Bedeutung. Das kann vor allem <strong>beim Vorlesen von Geschichten </strong>heißen, dass zum Beispiel zwischen 
               <strong>unterschiedlichen Stimmen der Charaktere gewechselt wird</strong>, um das Vorgelesene <strong>interessanter für</strong> <strong>
               die Zuhörenden</strong> zu gestalten. Eine <strong>Variationsfähigkeit der Stimme</strong> zwischen hoch, tief, laut und leise kann hierfür 
               also <strong>von Nutzen sein</strong><span >. </span>Häufig sind die <strong>Übergänge fließend</strong>: Eine 
               besonders spannende Passage eines Textes kann beispielsweise <strong>geflüstert begonnen</strong> und <strong>allmählich stimmlich 
               lauter</strong> und dringlicher ausgestaltet werden. <strong>Unterschiedliche Sprechweisen</strong>, wie etwa laut, leise, hoch oder 
               tief, erfordern <strong>verschiedene (Kraft-) Anstrengungen unserer am Sprechen beteiligten Muskeln</strong>. Wenn wir Flüstern ist die 
               <strong>Spannung der Stimmlippen</strong>, aufgrund ihrer Stellung, zum Beispiel sehr hoch, was bedeutet, dass Flüstern <strong>die 
               Stimme allgemein anstrengt </strong>(siehe oben). Eventuell folgt nun eine Textpassage, die in <strong>Indifferenzlage </strong>gesprochen 
               werden kann. Hier ist die Spannung auf Stimmlippenebene nun <strong>weniger stark als beim Flüstern</strong>, die Stimme kann sich also 
               <strong>entspannen</strong>. Dieses Beispiel verdeutlicht den <strong>regen Wechsel zwischen Spannung und Entspannung</strong> auf 
               <strong>Stimmlippenebene</strong>, der zwar herausfordernd, aber mit etwas Übung leichter <strong>zu bewältigen ist</strong>.<br />
                <br />

                <h5 class="mb-2"><u>Tipps zum stimmschonenden Vorlesen</u></h5>

                <p><strong>1. Stimme aufwärmen:</strong> Wärmen Sie Ihre Stimme vor dem Vorlesen mit einfachen Stimm-Übungen auf. Hier eignet sich ein einfaches Lippenflattern und kurze auf- und absteigende Phrasen mit einem „uiuiuiuiui“ oder auch „blablablablabla“.</p>

                <p><strong>2. Viel Trinken</strong> (am besten Wasser). Während des Vorlesens Trinkpausen nutzen, um die Stimmlippen feucht zu halten. Der Schluckvorgang entspannt außerdem den gesamten Stimmapparat.</p>

                <p><strong>3. Bewusst Pausen setzen:</strong> So können die Zuhörenden besser folgen und Sie sich eine kurze Pause gönnen. Atmen Sie in den Pausen tief und versuchen Sie, eventuellen Verspannungen (Schultern, Nacken, Kiefer) im Körper entgegenzutreten (siehe Übungen in Lerneinheit „Gesunderhaltung der Stimme“).</p>

                <p><strong>4. Grenzen kennen:</strong> versuchen Sie stimmlich nicht über Ihre Grenzen zu gehen und reagieren Sie auf Ermüdungsanzeichen Ihrer Stimme wie beispielsweise Halskratzen, erhöhtes Räusperbedürfnis oder Hustenreiz. Vielleicht mag ein*e Schüler*in weiterlesen?<br />
                &nbsp;</p>

                Die <strong>vier folgenden Tipps</strong> und <strong>Übungen</strong> können Ihnen helfen, sich auf das <strong>Vorlesen</strong> 
                vorzubereiten und der Stimme <strong>mehr Routine mit dieser Sprechweise</strong> zu ermöglichen.<br />
                &nbsp;</p>
            </div>

            <div className="lehguParagraph ">
            <h5><u><span >Weitere Übungen zur Stimme finden Sie hier:</span></u></h5>

                <ul>
                    <li><span ><a className="btn btn-outline-primary" href="https://lehgu.de/prof/lerneinheiten/page/543">
                    Übungen zur Indifferenzlage</a>&nbsp;
                    </span></li>
                    <li><span ><a className="btn btn-outline-primary" href={"https://lehgu.de/prof/lerneinheiten/page/588"}>
                    Basale Stimmübung 1-3</a>&nbsp;
                    </span></li>
                </ul>

            </div>

            <div className="pageBottomButtonsWrapper contentElement">
                        <a className="btn pageBottomButtonLeft " href="https://lehgu.de/prof/lerneinheiten/page/719" >Zurück</a>
                        <a className="btn pageBottomButtonRight " href="https://lehgu.de/prof/lerneinheiten/page/717" >Weiter</a>
                    </div>


         

        </div>


    </div>
)